import React, { useEffect } from 'react';
import { companyInfo, aboutImages } from '../mock';
import Footer from '../components/Footer';

const About = () => {
  useEffect(() => {
    // Set page-specific meta tags
    document.title = 'Om Fryd! - Dansk håndværk i træ | Tømrer & Snedkerfirma';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Fryd! forener dansk kulturarv med moderne håndværk. Vi arbejder med arkitekter og skaber unikke løsninger i træ med kompromisløs kvalitet.');
    }
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://ffryd.dk/om');
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Content Section with image */}
      <div className="px-8 md:px-16 py-32">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-16">
            <h1 className="text-4xl md:text-6xl font-light text-gray-900 mb-8">
              Om Fryd!
            </h1>
            <p className="text-2xl md:text-3xl font-light text-gray-700 italic mb-4">
              {companyInfo.tagline}
            </p>
          </div>

          {/* Image with frame like Projects */}
          <div className="mb-16">
            <div className="relative overflow-hidden aspect-[16/9] rounded">
              <img
                src="https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/3whx5keo_IMG_0010%20%284%29.jpg"
                alt="Fryd! håndværk"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Main Description - No box, just text */}
          <div className="space-y-8">
            <p className="text-2xl md:text-3xl font-light text-gray-900 leading-relaxed">
              Fryd!
            </p>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              Hos Fryd! bygger vi ikke for hvem som helst, og vi bygger ikke hvad som helst.
            </p>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              Vi forener det bedste fra den danske kulturarv med de projekter, hvor faglighed, æstetik og håndværk sættes på prøve.
              Vi arbejder med arkitekter, der tør stille krav til hvordan man arbejder med træ, fordi vi taler samme sprog. Bag hver streg, hver detalje og hver beslutning ligger et ansvar, vi kender. Når idéen er kompleks, detaljen ufravigelig, og kompromiser ikke en mulighed, træder vi til.
            </p>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              Alt, vi skaber, udspringer af forståelse. Forståelse for materialet, for håndværket og for visionen bag. Vi bygger med hænderne, med viden, præcision og kærlighed til træ, så hver eneste løsning hænger sammen i helheden og i detaljen.
              Vores team er håndplukket. Mennesker, der kan selv, vil selv og tør stå inde for deres arbejde. For hos os handler byggeri ikke kun om resultatet. Det handler om processen, om tryghed og om den ro, der opstår, når idé og udførelse mødes - præcis som det var tænkt.
            </p>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              Det er Fryd.
            </p>
          </div>
        </div>
      </div>

      {/* Footer Contact Section */}
      <Footer />
    </div>
  );
};

export default About;
